import {
  ElementKind,
  elementKinds,
  IBuilding,
  Baseline,
  IElement,
  IProductElement,
  Project,
} from '@shared/models/project.model';
import { guards } from '../typeguards.helpers';

const isProject = (maybeProject?: unknown): maybeProject is Project => {
  return (
    guards.is.object(maybeProject) &&
    guards.is.array(maybeProject.baselines) &&
    guards.is.string(maybeProject.name) &&
    guards.is.defined(maybeProject.id)
  );
};

/**
 * @deprecated The building layer was flattened into {@link Project} (DEV-2576).
 * Also matches {@link Project} because `baselines` now lives there. Use
 * {@link projectGuards.is.project} first when the two must be distinguished.
 */
const isBuilding = (maybeBuilding: unknown): maybeBuilding is IBuilding => {
  return (
    guards.is.object(maybeBuilding) && guards.is.array(maybeBuilding.baselines)
  );
};

const getElementKind = (element?: unknown): ElementKind | undefined =>
  guards.is.object(element) &&
  elementKinds.includes(element.kind as ElementKind)
    ? (element.kind as ElementKind)
    : undefined;

export const projectGuards = {
  is: {
    element: (element: unknown): element is IElement => {
      return getElementKind(element) === ElementKind.Element;
    },
    productElement: (element: unknown): element is IProductElement => {
      return getElementKind(element) === ElementKind.Product;
    },
    buildingVersion: (element: unknown): element is Baseline => {
      return getElementKind(element) === ElementKind.Version;
    },
    building: isBuilding,
    project: isProject,
  },
};
